import React, { Component } from 'react';
import {connect} from 'react-redux';
import { Link } from 'react-router-dom';

import config from 'config/config';
import {init} from "redux/actions/steps";
import Modal from 'components/common/modal/Modal';

import './Login.css';


class Login extends Component {

  constructor(props) {
    super(props);

    if (!props.steps.isGet) {
      props.dispatch(init());
    }

    const state = props.location.state || {};
    const params = new URLSearchParams(state.prevSearch);

    this.state = {
      err: params.get('msg'),
      title: props.title === 'login' ? 'Log in your Iterio Data account' : 'Create your Iterio Data account'
    };
  }

  componentDidMount() {
    if (this.state.err) {
      this._modal.openModal();
      this._modal.setState({content: this.state.err});
    }
  }

  render() {
    if (!this.props.steps.isGet) return (<span/>);
    return (
      <div className="c-login gradient full-screen">
        <div className="content">
          <h1>{this.state.title}</h1>

          {
            this.props.title === 'login' ?
              <p>Don't have an account? <br/><Link to='/signup' className="link">Sign up</Link></p> :
              <p>Already have an account? <br/><Link to='/login' className="link">Log in</Link></p>
          }

          <div className="block">
            <div className="buttons clearfix">
              <a href={`${config.apiDomain}/v1/facebook_login`} className="facebook link">Facebook</a>
              <a href={`${config.apiDomain}/google_login`} className="google link">Google</a>
            </div>
          </div>
        </div>

        <Modal
          className='c-login__modal'
          ref={(modal) => { this._modal = modal; }}
          title={(<h2>Handler error connect</h2>)}
        />
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {steps:state.steps};
}

export default connect(mapStateToProps)(Login);



// WEBPACK FOOTER //
// ./src/components/core/login/Login.jsx